const items = {
  "auth.role.label": "角色",
  "auth.role.all": "全部角色",
  "auth.role.owner": "拥有者",
  "auth.role.manager": "管理员",
  "auth.role.editor": "编辑者",
  "auth.role.member": "成员",
  "auth.role.student": "学生",
  "auth.role.assistant": "助理老师",
  "auth.role.unknown": "未知",
  "auth.role.delete": "已删除",
  "auth.role.reader": "阅读者",
  "auth.type.user": "用户",
  "auth.type.group": "群组",
  "auth.sign-up.email-certification": "邮箱验证",
  "auth.sign-up.info": "完善个人信息",
};

export default items;
